import { useMemo } from 'react';
import { formatActivityStatus } from '../utils/dateHelpers';

/**
 * useActivityStatus — combines heartbeat presence and last_active_at into a single status.
 *
 * "Active now" means one thing: the peer is in this chat with you right now (heartbeat).
 * Everything else comes from the time ladder: "Active Xm/Xh/X days ago."
 *
 * Chat pages pass peerOnline from useHeartbeat; detail pages pass null.
 *
 * @param {boolean|null} peerOnline - From useHeartbeat (true/false), or null if not in a chat context
 * @param {string|null} lastActiveAt - ISO timestamp from peer's profiles.last_active_at
 * @returns {{ text: string, isActive: boolean } | null}
 */
const useActivityStatus = (peerOnline, lastActiveAt) => {
  return useMemo(() => {
    // Heartbeat says peer is in this chat right now — only source of "Active now"
    if (peerOnline === true) {
      return { text: 'Active now', isActive: true };
    }

    // Fall through to time ladder — always returns minutes/hours/days, never "Active now"
    return formatActivityStatus(lastActiveAt);
  }, [peerOnline, lastActiveAt]);
};

export default useActivityStatus;
